import {Config, ISteps} from "./config-viewmodel";

export interface MyStudyChoiceOnboardingModelState {
    config: Config
    steps: ISteps
    myStudyChoice: string
    activeStepIndex: number
    activeSubStepIndex: number
    reverse: boolean
    onboardingIsActive: boolean
    onboardingIsCompleted: boolean
    canContinue: boolean
}

export class WidgetState implements MyStudyChoiceOnboardingModelState {
    config: Config = {
        labels: {
            activityChoiceTitle: '',
            availableActivities: '',
            subscribedActivities: '',
            signUpForStudyChoiceActivitiesTitle: '',
            signUpForStudyChoiceActivitiesDescription: '',
            myStudyChoiceWelcomeTitle: '',
            myStudyChoiceWelcomeDescription: '',
            iAmInterestedIn: '',
            iAmInterestedInDescription: '',
            iAmInterestedInBachelor: '',
            iAmInterestedInMaster: '',
            iAmInterestedInBoth: '',
            signUpButton: '',
            signOutButton: '',
            route: '',
            viewingAndEditingSessions: '',
            saveDate: '',
            welcome: '',
            activities: '',
            closeNotificationTitle: '',
            closeNotificationDescription: '',
            closeNotificationCloseButton: '',
            closeNotificationContinueButton: '',
            nextStep: '',
            previousStep: '',
            completeOnboarding: '',
        }
    }
    steps: ISteps = []
    myStudyChoice: string = ''
    activeStepIndex: number = 0
    activeSubStepIndex: number = 0
    reverse: boolean = false
    onboardingIsActive = false
    onboardingIsCompleted = true
    canContinue: boolean = false
}